<template>
    <!-- Importing Home Component -->
    <comComp></comComp>
  </template>
  <script>
  import comComp from "../components/CommisionReport.vue";
  
  export default {
    name: "Commission Report",
    components: { comComp },
    computed: {},
    mounted() {},
  };
  </script>
  